// extracted by mini-css-extract-plugin
export default {"background":"LoginButton_background__ZUiUh"};